import { PaletteMode } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { Locales } from '@/infrastructure/enum/locales';
import { lightTheme } from './light-theme';
import { darkTheme } from './dark-theme';
import { TLocales } from '../../type/locales';
import { Inter } from '../../../assets/fonts/inter/local-font';
import { SFArabic } from '../../../assets/fonts/sf-arabic/local-font';

export class MUITheme {
  static createTheme(mode: PaletteMode, locale: TLocales | string) {
    const fontFamily =
      locale === Locales.ar
        ? SFArabic.style.fontFamily
        : Inter.style.fontFamily;
    const theme = mode === 'light' ? lightTheme : darkTheme;
    return createTheme({
      direction: locale === Locales.ar ? 'rtl' : 'ltr',
      typography: {
        fontFamily: fontFamily,
        fontWeightMedium: 400,
      },
      components: {
        MuiInputBase: {
          defaultProps: {
            style: {
              borderRadius: '10px',
            },
          },
        },
      },
      ...theme,
    });
  }
}
